export function capitalize(s) {
    if (!s || typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

export function stringHash(s) {
    var hash = 0, i, chr;
    if (s.length === 0) return hash;
    for (i = 0; i < s.length; i++) {
        chr = s.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export function revealPrompt(prompt) {
    return capitalize(prompt)
}